// Exact projection/controller from KZ d212e5e; only module wrapper/timer names adapted. Read-only authority and query preserved.
    const authority = Object.freeze({
        planId: 'chinese-a-20260930-textbook-sequence-v6', version: '1.3.0',
        planDigest: 'd2a6d3e397b4f586e17bcf64855d947d35162acec17527b2e4ab1082c8828eca',
        sourceCatalogDigest: '7a2dd4a1de8507a3542845a119b473625f146f4efc5682c7fd19b85f463c8624',
    });
    const gates = Object.freeze([
        { id: 'ai-lunyu-30', title: '研讀', mode: 'read', unit: '展開譯註的有效紀錄' },
        { id: 'lunyu-battle-30', title: '義戰論語', mode: 'battle', unit: '提交作答的有效紀錄；不代表全部答對' },
    ]);
    const dayAt = ms => new Date(ms + 8 * 3600000).toISOString().slice(0, 10);
    // /api/session exposes the central users.slug UNIQUE key, not the private
    // numeric id. Never use display names, email or inferred aliases as identity.
    const ownerOf = session => session?.authenticated === true && typeof session.user?.slug === 'string'
        && session.user.slug.length > 0 ? session.user.slug : null;
    const relevant = task => ['kz', 'ly', 'fuzi', 'weibian'].includes(task?.siteKey)
        || (task?.addenda || []).some(part => ['kz', 'ly', 'fuzi', 'weibian'].includes(part?.siteKey));
    function projection(payload, day) {
        if (payload?.schemaVersion !== 'student-progress-v1'
            || payload?.academicYear?.id !== payload?.currentAcademicYear
            || !payload?.currentAcademicYear
            || !Number.isFinite(Date.parse(payload?.generatedAt))
            || dayAt(Date.parse(payload.generatedAt)) !== day
            || payload?.daily?.day?.date !== day
            || !Object.entries(authority).every(([key, value]) => payload.daily.authority?.[key] === value)
            || !Array.isArray(payload?.daily?.day?.tasks)) throw Error('daily_source_unverified');
        const complete = payload?.coverage?.sourceReadStatus === 'ok'
            && payload.coverage.rawProgressLimitReached === false && payload.coverage.rawRecordLimitReached === false;
        const requirements = payload?.score?.aPlus?.requirements;
        if (!Array.isArray(requirements)) throw Error('progress_source_unverified');
        const progress = gates.map(gate => {
            const found = requirements.filter(item => item.id === gate.id);
            const item = found.length === 1 ? found[0] : null;
            const verified = complete && item && ['completed', 'incomplete'].includes(item.status)
                && typeof item.current === 'string' && item.current.trim().length > 0;
            return { ...gate, verified: Boolean(verified), current: verified ? item.current : '紀錄暫未核齊',
                status: verified ? item.status : 'unverified' };
        });
        const tasks = payload.daily.day.tasks.filter(relevant).map(task => {
            if (!task.taskId || typeof task.title !== 'string' || typeof task.action !== 'string'
                || typeof task.completionCheck !== 'string') throw Error('daily_task_incomplete');
            return { taskId: task.taskId, title: task.title, action: task.action,
                details: Array.isArray(task.details) ? task.details.filter(t => typeof t === 'string') : [],
                completionCheck: task.completionCheck, scoringStatus: complete ? task.scoringStatus : 'source_unverified',
                chapterIds: [...new Set((task.taskRefs || []).map(ref => /^source:kz:chapter-([1-9]\d*)$/.exec(ref)?.[1]).filter(Boolean))],
                mode: task.siteKey === 'kz' ? 'read' : task.siteKey === 'ly' ? 'battle' : null };
        });
        return { day, year: payload.currentAcademicYear, generatedAt: payload.generatedAt, tasks, progress };
    }
    function controller({ identity, render, now = Date.now, deadlineMs = 12000 }) {
        let generation = 0;
        const clear = () => { generation += 1; render({ state: 'idle' }); };
        async function refresh() {
            const request = ++generation, day = dayAt(now());
            render({ state: 'loading' });
            const bounded = promise => new Promise((resolve, reject) => {
                const timer = setTimeout(() => reject(Error('read_timeout')), deadlineMs);
                Promise.resolve(promise).then(resolve, reject).finally(() => clearTimeout(timer));
            });
            try {
                const service = identity();
                if (!service?.getSession || !service?.api) throw Error('identity_unavailable');
                const before = ownerOf(await bounded(service.getSession()));
                if (request !== generation) return;
                if (!before) { render({ state: 'anonymous' }); return; }
                const payload = await bounded(service.api('/api/student-progress?' + new URLSearchParams({ date: day, site: 'kz', limit: '1' })));
                if (request !== generation) return;
                const after = ownerOf(await bounded(service.getSession()));
                if (request !== generation) return;
                if (!after || before !== after) { render({ state: 'identity_changed' }); return; }
                if (day !== dayAt(now())) { render({ state: 'date_changed' }); return; }
                render({ state: 'ready', view: projection(payload, day) });
            } catch (_) { if (request === generation) render({ state: 'unavailable' }); }
        }
        return Object.freeze({ refresh, clear });
    }

export { projection, controller, dayAt };
